import {TTypeReference} from '@packages/systems/wfdl-ast';

export const extraAtomFields = TTypeReference('extraAtomFields');
